import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { ModeratorDashboard } from '../components/moderation/ModeratorDashboard';
import { Layout } from '../components/layout/Layout';

const ModerationPage = () => {
  const router = useRouter();

  const handleBack = () => {
    router.navigate({ to: '/dashboard' });
  };

  return (
    <Layout pageTitle="Moderation Center" showBackButton onBack={handleBack}>
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 overflow-x-hidden">
        <ModeratorDashboard />
      </div>
    </Layout>
  );
};

export const Route = createFileRoute('/moderation')({
  component: ModerationPage,
  beforeLoad: ({ context }: any) => {
    // Redirect to login if not authenticated
    if (!context.auth?.isAuthenticated) {
      throw redirect({ to: '/' });
    }
    
    // Redirect to dashboard if not a moderator or administrator
    if (!['MODERATOR', 'ADMINISTRATOR'].includes(context.auth?.user?.role || '')) {
      throw redirect({ to: '/dashboard' });
    }
  },
});
